import type { captureException as sentryCaptureException } from "./sentry";

const loadSentry = () => import("./sentry");

export async function captureException(
  exception: any,
  captureContext?: Parameters<typeof sentryCaptureException>[1],
) {
  const Sentry = await loadSentry();
  return Sentry.captureException(exception, captureContext);
}
